const events = require("./auditCreationEvents.js");

const auditCreationHandlers = {
    [events.Started.Name](prev, event) {
        const update = {
            SurveyCreationStatus: {
                InProgress: true,
                Error: null
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.Completed.Name](prev, event) {
        const update = {
            SurveyCreationStatus: {
                InProgress: false,
                Error: null
            },
            SurveySearchResults: Object.assign({}, prev.SurveySearchResults, {
                Data: null
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.Errored.Name](prev, event) {
        const update = {
            SurveyCreationStatus: {
                InProgress: false,
                Error: event.Error
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ClearError.Name](prev, event) {
        const update = {
            SurveyCreationStatus: {
                InProgress: false,
                Error: null
            }
        };

        const result = Object.assign({}, prev, update);

        return result;
    }
};

module.exports = auditCreationHandlers;


// WEBPACK FOOTER //
// ./src/events/auditCreation/auditCreationHandlers.js